import { createSelector } from "@reduxjs/toolkit";

export const getTables = createSelector(
  (state) => state.tables.list,
  (list) => list
);
